/**
 * Generated by orval v6.29.0 🍺
 * Do not edit manually.
 * Cloudsaver.Customers.Host.Api
 * OpenAPI spec version: 1.0
 */

/**
 * @nullable
 */
export type RoleCompanyType = typeof RoleCompanyType[keyof typeof RoleCompanyType] | null;


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RoleCompanyType = {
  Customer: 'Customer',
  StrategicPartner: 'StrategicPartner',
  Msp: 'Msp',
  Support: 'Support',
  PlatformSupport: 'PlatformSupport',
} as const;
